import { FETCH_CONTACT_OPTIONS, UPDATE_DISPLAY_COMPONENT } from './constants'

export const fetchContactOptions = {
  request: () => ({
    type: FETCH_CONTACT_OPTIONS['REQUEST'],
  }),
  success: contactOptions => ({
    type: FETCH_CONTACT_OPTIONS['SUCCESS'],
    contactOptions
  })
}

export const updateDisplayComponent = component => ({
  type: UPDATE_DISPLAY_COMPONENT,
  component
})



// WEBPACK FOOTER //
// ./src/containers/ContactUsModal/actions.js